module.exports = __webpack_public_path__ + "assets/img/poster-vip1.2571fd19.png";